export interface IGetFormedChangedComplexDataProps<T> {
  field: string
  value: any
  index: number
  data: T[]
}

export interface IGetFormedChangedComplexDataByKey<T> {
  field: string
  value: string | number
  keyValue: string
  keyField: string
  data: T[]
}

export const getFormedChangedComplexData = <T>({
  field,
  value,
  index,
  data,
}: IGetFormedChangedComplexDataProps<T>) => {
  const sectionData = data
  sectionData[index] = { ...sectionData[index], [field]: value }
  return sectionData
}

export const getFormedChangedComplexDataByKey = <T>({
  field,
  value,
  keyValue,
  keyField,
  data,
}: IGetFormedChangedComplexDataByKey<T>) => {
  const sectionData = data
  const updatedItemIndex = sectionData.findIndex((el) => el[keyField] === keyValue)
  if (updatedItemIndex > -1) {
    sectionData[updatedItemIndex] = { ...sectionData[updatedItemIndex], [field]: value }
  }
  return sectionData
}
